import { Component } from '@angular/core';
import { UIModule } from '@bannerflow/ui';
import { AppComponent } from '../../app.component';

@Component({
    imports: [UIModule],
    selector: 'studio-maintenance',
    templateUrl: 'maintenance-page.component.html',
    styleUrls: ['maintenance-page.component.scss']
})
export class MaintenanceComponent {
    constructor(private app: AppComponent) {
        this.app.loaded.set(true);
    }
}
